// extracted by mini-css-extract-plugin
module.exports = {"propiedades":"listadoPropiedades-module--propiedades--DlWfn"};